module.exports = __webpack_public_path__ + "img/person_logo.8ff321da.svg";